import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import { Theme } from '../../config/theme';

import ActivityBadge from '../ActivityBadge';

let styles;
const CHECK_ASSET = require('./check.svg');

export default class ActivityCard extends Component {
  constructor(props) {
    super(props);
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  toggleSelected() {
    if (this.props.profileHandler) {
      this.props.onSelect(this.props.name, this.props.id, !this.props.value);
    } else {
      this.props.onSelect(!this.props.value, this.props.id);
    }
  }

  render() {
    return (
      <div
        role="button"
        tabIndex={0}
        className={this.props.value ?
            css(styles.activity_card, styles.activity_card_selected, this.props.styles)
          :
            css(styles.activity_card, this.props.styles)
        }
        onClick={this.toggleSelected}
      >
        {this.props.activity ? <ActivityBadge activity={this.props.activity} /> : null}
        <span className={css(styles.activity_label)}>{this.props.label}</span>
        <Isvg
          cacheGetRequests
          src={CHECK_ASSET}
          className={this.props.value ?
            css(styles.check, styles.check_visible)
          :
            css(styles.check)
          }
        />
      </div>
    );
  }
}

ActivityCard.defaultProps = {
  styles: null,
  onSelect: () => {},
  value: false,
  id: 0,
  profileHandler: false,
  name: null,
};

ActivityCard.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  profileHandler: PropTypes.bool,
  value: PropTypes.bool,
  onSelect: PropTypes.func,
  activity: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.number,
  name: PropTypes.string,
};

styles = StyleSheet.create({
  activity_card: {
    display: 'flex',
    alignItems: 'center',
    width: 250,
    height: 82,
    padding: 20,
    color: '#828282',
    backgroundColor: '#f4f4f4',
    border: 'solid 1px #e0e0e0',
    borderRadius: 5,
    margin: '6px 10px',
    cursor: 'pointer',
    transition: 'box-shadow 300ms, background-color 300ms, border-color 300ms, color 300ms',
    outline: 'none',
    'user-select': 'none',
    ':hover': {
      color: '#000e1f',
      backgroundColor: '#fff',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    },
    [Theme.mobile_query]: {
      width: '100%',
      height: 62,
      margin: '6px 0',
      flexShrink: 0,
    },
  },
  activity_card_selected: {
    color: '#000e1f',
    backgroundColor: '#fff',
    borderColor: Theme.primary,
    boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ${Theme.primary} inset`,

    [Theme.mobile_query]: {
      height: 62,
    },

    ':hover': {
      boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 0 1px ${Theme.primary} inset`,
    },
  },
  activity_label: {
    flexGrow: 1,
    marginLeft: 10,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
  },
  check: {
    display: 'block',
    marginRight: 5,
    opacity: 0,
    transition: 'opacity 300ms',
  },
  check_visible: {
    opacity: 1,
  },
});



// WEBPACK FOOTER //
// ./src/components/ActivityCard/index.js